// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowPartialRotateLeft16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-partial-rotate-left': IconArrowPartialRotateLeft;
    }
}

/**
 * The icon component for the 'arrowPartialRotateLeft' icon
 */
export class IconArrowPartialRotateLeft extends Icon {
    public constructor() {
        super(arrowPartialRotateLeft16X16);
    }
}

registerIcon('icon-arrow-partial-rotate-left', IconArrowPartialRotateLeft);
export const iconArrowPartialRotateLeftTag = 'nimble-icon-arrow-partial-rotate-left';
